















import Vue from 'vue'
import { IDevice, IVW } from '@/types/model'
import { api } from '@/singleton'
import mixins from 'vue-typed-mixins'
import { vwDialogMixin } from '@/mixins'
import easyapi from '@/easyapi'

export default mixins(vwDialogMixin).extend({
  computed: {
    vw (): IVW | null { return this.dialog.vw }
  },
  methods: {
    async apply () {
      if (!this.vw) { return }
      const ok = await easyapi.deleteVw(this.vw.id)
      if (ok) {
        this.closeThisDialog()
      }
    }
  },
})
